import { Button, Col, Input, Row, Space, Table, Tag } from "antd";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { WebRoutes } from "../../shared/constants/WebRoutes";
import { useNavigate } from "react-router-dom";
import { setFiltersAdminPanel } from "../../features/adminPanel/adminPanelSlice";
import { StatusTranslations } from "../../shared/constants/Status";
import { getUserRequestsExcel } from "../../services/userRequestApi";
import dayjs from "dayjs";
import { selectCurrentAdminPartner } from "../../utils/helpers/selectorHelper";
import { getBackgroundByStatus } from "../userRequest/listBeta/utils";

const { Column } = Table;
const { Search } = Input;

const AdminPanelTrips = () => {
  const {
    value: adminPanel,
    filtersAdminPanel: filters,
    loading,
  } = useAppSelector((state) => state.adminPanel);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onSearch = (searchText: string) => {
    const newFilters = { ...filters, page: 1, searchText };
    dispatch(setFiltersAdminPanel(newFilters));
  };

  const handleExportExcel = async () => {
    const result = await getUserRequestsExcel({
      startDate: dayjs(filters.startDate).toDate(),
      endDate: dayjs(filters.endDate).toDate(),
      shouldSendCompany: false,
      adminId: filters.adminId,
    });

    const link = document.createElement("a");
    link.href = result;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onChangePagination = (currentPage: number, pageSize: number) => {
    const newFilters = { ...filters, page: currentPage, take: pageSize };
    dispatch(setFiltersAdminPanel(newFilters));
  };

  const showTotal = (total: number) => `Total de viajes ${total} `;

  const isAdminPartner = selectCurrentAdminPartner();

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>Viajes recientes</Col>
      <Col span={24}>
        <Space>
          <Button onClick={handleExportExcel}>Generar reporte</Button>
          <Search
            placeholder="Buscar..."
            onSearch={onSearch}
            style={{ maxWidth: 400 }}
            allowClear
            loading={loading}
            disabled={loading}
          />
        </Space>
      </Col>
      <Col span={24} style={{ width: "100px", height: "42vh" }}>
        <Table
          dataSource={adminPanel?.userRequestAdminPanel || []}
          rowKey="id"
          pagination={{
            total: adminPanel?.total,
            onChange: onChangePagination,
            hideOnSinglePage: true,
            showSizeChanger: false,
            current: filters.page,
            showTotal,
          }}
          loading={loading}
          scroll={{ y: "calc(-250px + 60vh)" }}
        >
          <Column title="Hora de finalizacion" dataIndex="finishedAt" />
          <Column title="ID" dataIndex="id" />
          <Column title="Cliente" dataIndex="passengerName" />
          <Column title="Departamento" dataIndex="department" />
          <Column title="Conductor" dataIndex="providerName" />
          <Column
            title="Det. Viaje"
            render={(record) => {
              return (
                <Button
                  type="link"
                  onClick={() => {
                    navigate(
                      `${WebRoutes.AdminPanelTripDetails}/${record.id}`,
                      {
                        state: { ...record, navigationType: "Admin" },
                        replace: true,
                      },
                    );
                  }}
                >
                  Ver detalles del viaje
                </Button>
              );
            }}
          />
          <Column
            title="Estado"
            dataIndex="status"
            render={(item) => {
              const status = StatusTranslations.find((i) => i.name === item);
              if (status) {
                const color = getBackgroundByStatus(status?.translation);
                return (
                  <Tag color={color || ""}>
                    {status?.translation?.toUpperCase()}
                  </Tag>
                );
              }
              return <Tag>{item}</Tag>;
            }}
          />
          <Column
            title={`${isAdminPartner ? "Costo neto" : "Costo"}`}
            dataIndex="formattedTotal"
            render={(formattedTotal, record: any) => {
              return (
                <>
                  {record.qrFee > 0 ? (
                    <p className="paragraph">Efectivo</p>
                  ) : (
                    formattedTotal
                  )}
                </>
              );
            }}
          />
          {isAdminPartner && (
            <Column
              title="Código"
              dataIndex="comission"
              render={(comission) => {
                return comission?.toLocaleString("es-UY", {
                  style: "currency",
                  currency: "UYU",
                });
              }}
            />
          )}
        </Table>
      </Col>
    </Row>
  );
};

export default AdminPanelTrips;
